<template>

    <header class="header" itemscope itemtype="https://schema.org/Organization">

        <div class="container">

            <div class="header__wrapper">

                <div class="header__logo" itemprop="name">
                    <img class="header__logo-image" src="@/assets/images/nami-logo.png" alt="Служба технической поддержки мобильных и веб-приложений ФГУП НАМИ" title="Служба технической поддержки мобильных и веб-приложений ФГУП НАМИ">
                </div>

                <div class="header__address" itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
                    <span class="header__address-postcode" itemprop="postalCode">125438</span>, 
                    <span class="header__address-location" itemprop="addressLocality">Россия, г. Москва, </span> 
                    <span class="header__address-street" itemprop="streetAddress">ул.Автомоторная, д.2</span>
                    <br>
                    <a href="mailto:support.app@nami.ru" itemprop="email" class="header__address-email">support.app@nami.ru</a>
                </div>

                <div class="header__phone" itemprop="telephone">
                    <a class="header__phone-link" href="tel:+74954565700">+7(495)456-57-00</a> 
                    <span class="header__phone-additional">доб. 60-60</span>
                </div>

            </div>

        </div>

    </header>

</template>

<style lang="scss">
@import '@/assets/styles/scss/components/header';
</style>